import axios from "axios";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";
import axiosInstance from "../../../Hooks/axoisInstance";

const getToken = () => {
  return localStorage.getItem("token");
};
 
export const AllSecondaryCollectionTransaction = async (StartDate, endDate, zoneId, VehicleNumber,collectionPointName) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
      `RawReport/GetAllSecondaryCollectionTransaction?startDate=${StartDate}&endDate=${endDate}&zoneId=${zoneId}&VehicleNumber=${VehicleNumber}&collectionPointName=${collectionPointName}`,
      {
        headers:{
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const GetAllClearedHotspotTransaction = async (StartDate, endDate, ZoneId, circleId, shiftId,ownerTypeId,vehicleTypeId) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
      `TransactionReport/GetAllClearedCollectionPointTransaction?startDate=${StartDate}&endDate=${endDate}&ZoneId=${ZoneId}&circleId=${circleId}&shiftId=${shiftId}&ownerTypeId=${ownerTypeId}&vehicleTypeId=${vehicleTypeId}`,
      {
        headers:{
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetAllClearedHotspotTransactionTotal = async (StartDate, endDate, shiftId,ownerTypeId,vehicleTypeId) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
      `TransactionReport/GetAllClearedCollectionPointTransaction?startDate=${StartDate}&endDate=${endDate}&shiftId=${shiftId}&ownerTypeId=${ownerTypeId}&vehicleTypeId=${vehicleTypeId}`,
      {
        headers:{
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetAllTotalClearedHotspotTransaction = async (StartDate, endDate, shiftId,ownerTypeId,vehicleTypeId) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
      `TransactionReport/GetAllClearedCollectionPointTransaction?startDate=${StartDate}&endDate=${endDate}&shiftId=${shiftId}&ownerTypeId=${ownerTypeId}&vehicleTypeId=${vehicleTypeId}`,
      {
        headers:{
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
 
export const GetSecondaryVehicleNotReportedAtDeployment = async (StartDate, OwnerTypeId, CircleId, ShiftId) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
      `TransactionReport/GetSecondaryVehicleNotReportedAtDeployment?Date=${StartDate}&OwnerTypeId=${OwnerTypeId}&CircleId=${CircleId}&ShiftId=${ShiftId}`,
      {
        headers:{
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
 
export const GetAllSecondaryDeploymentTransaction = async (StartDate, endDate, OwnerTypeId, CircleId, ShiftId) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
      `TransactionReport/GetAllSecondaryDeploymentTransaction?startDate=${StartDate}&endDate=${endDate}&OwnerTypeId=${OwnerTypeId}&CircleId=${CircleId}&ShiftId=${ShiftId}`,
      {
        headers:{
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
 
export const GetAllVehicleDetailsByFilters = async (IsActive, circleId) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
      `MasterDetails/GetAllVehicleDetailsByFilters?IsActive=${IsActive}&circleId=${circleId}`,
      {
        headers:{
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
 
export const GetAllClearedCollectionPointTransaction = async (StartDate, endDate, CircleId, ShiftId) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
      `TransactionReport/GetAllClearedCollectionPointTransaction?startDate=${StartDate}&endDate=${endDate}&CircleId=${CircleId}&ShiftId=${ShiftId}`,
     {
        headers:{
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const TotalDeploymentTransaction = async (
  StartDate,
  endDate,
  ownerTypeId,
  shiftId,
  vehicleTypeId
) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `RawReport/GetAllSecondaryDeploymentTransaction?startDate=${StartDate}&endDate=${endDate}&ownerTypeId=${ownerTypeId}&shiftId=${shiftId}&vehicleTypeId=${vehicleTypeId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};